import { Component, Input, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FIKO_DIALOG_STIL } from './fiko-dialog-stil';
import { FikoDuzlemSecici } from './FikoDuzlemSecici';

/**
 * CATIA Line Definition (GSD wireframe) — çok-modlu çizgi penceresi.
 * Tür: İki Nokta (point-point, koordinat/referans) · Nokta-Yön (point-direction, eksen+uzunluk).
 */
@Component({
  selector: 'fikoyt-cizgi-dialog',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, FormsModule, FikoDuzlemSecici],
  template: `
  <div class="sd" *ngIf="el && yon">
    <div class="sd-grup">
      <div class="sd-bas">Çizgi Türü</div>
      <div class="sd-row"><label>Tür</label>
        <select [ngModel]="el.cizgiTip || 'iki-nokta'" (ngModelChange)="set('cizgiTip',$event)">
          <option value="iki-nokta">İki Nokta (Point-Point)</option>
          <option value="nokta-yon">Nokta-Yön (Point-Direction)</option>
          <option value="aci">Açı (Angle to Line)</option>
          <option value="bisecting">Açıortay (Bisecting)</option>
          <option value="tanjant">Eğriye Teğet (Tangent)</option>
          <option value="normal">Düzleme/Yüzeye Normal</option>
        </select>
      </div>
    </div>

    @if((el.cizgiTip || 'iki-nokta') === 'iki-nokta' || el.cizgiTip === 'nokta-yon' || el.cizgiTip === 'normal'){
      <div class="sd-grup">
        <div class="sd-bas">Başlangıç</div>
        <div class="sd-row"><label>Nokta</label>
          <select [ngModel]="el.ref1 ?? -1" (ngModelChange)="setNum('ref1',$event)">
            <option [value]="-1">— Koordinat —</option>
            @for(o of noktalar(); track o.deger){ <option [value]="o.deger">{{o.etiket}}</option> }
          </select><button class="sd-pick" (click)="ref3d('ref1','nokta3d')" title="3D'den seç">🎯</button></div>
        @if((el.ref1 ?? -1) < 0){
          <div class="sd-row"><label>X</label><div class="sd-num"><input type="number" step="1" [ngModel]="el.p1x ?? 0" (ngModelChange)="setNum('p1x',$event)"/></div></div>
          <div class="sd-row"><label>Y</label><div class="sd-num"><input type="number" step="1" [ngModel]="el.p1y ?? 0" (ngModelChange)="setNum('p1y',$event)"/></div></div>
          <div class="sd-row"><label>Z</label><div class="sd-num"><input type="number" step="1" [ngModel]="el.p1z ?? 0" (ngModelChange)="setNum('p1z',$event)"/></div></div>
          <button class="sd-btn sd-sec" (click)="koord3d('p1x','p1y','p1z')">🎯 Yüze / 3D'ye Tıkla</button>
        }
      </div>
    }

    @if((el.cizgiTip || 'iki-nokta') === 'iki-nokta'){
      <div class="sd-grup"><div class="sd-bas">Bitiş</div>
        <div class="sd-row"><label>Nokta</label>
          <select [ngModel]="el.ref2 ?? -1" (ngModelChange)="setNum('ref2',$event)">
            <option [value]="-1">— Koordinat —</option>
            @for(o of noktalar(); track o.deger){ <option [value]="o.deger">{{o.etiket}}</option> }
          </select><button class="sd-pick" (click)="ref3d('ref2','nokta3d')" title="3D'den seç">🎯</button></div>
        @if((el.ref2 ?? -1) < 0){
          <div class="sd-row"><label>X</label><div class="sd-num"><input type="number" step="1" [ngModel]="el.p2x ?? 40" (ngModelChange)="setNum('p2x',$event)"/></div></div>
          <div class="sd-row"><label>Y</label><div class="sd-num"><input type="number" step="1" [ngModel]="el.p2y ?? 0" (ngModelChange)="setNum('p2y',$event)"/></div></div>
          <div class="sd-row"><label>Z</label><div class="sd-num"><input type="number" step="1" [ngModel]="el.p2z ?? 0" (ngModelChange)="setNum('p2z',$event)"/></div></div>
          <button class="sd-btn sd-sec" (click)="koord3d('p2x','p2y','p2z')">🎯 Yüze / 3D'ye Tıkla</button>
        }
      </div>
    } @else if(el.cizgiTip === 'nokta-yon'){
      <div class="sd-grup"><div class="sd-bas">Yön & Uzunluk</div>
        <div class="sd-row"><label>Yön</label>
          <select [ngModel]="el.eksenTip || 'x'" (ngModelChange)="set('eksenTip',$event)">
            <option value="x">X Ekseni</option><option value="y">Y Ekseni</option><option value="z">Z Ekseni</option>
          </select></div>
        <div class="sd-row"><label>Uzunluk</label><div class="sd-num"><input type="number" min="0.1" step="1" [ngModel]="el.param ?? 40" (ngModelChange)="setNum('param',$event)"/><span>mm</span></div></div>
      </div>
    } @else if(el.cizgiTip === 'aci'){
      <div class="sd-grup"><div class="sd-bas">Açı (Referans Çizgiye)</div>
        <div class="sd-row"><label>Referans Çizgi</label>
          <select [ngModel]="el.ref1 ?? -1" (ngModelChange)="setNum('ref1',$event)">
            <option [value]="-1">— seç —</option>
            @for(o of cizgiler(); track o.deger){ <option [value]="o.deger">{{o.etiket}}</option> }
          </select><button class="sd-pick" (click)="ref3d('ref1','cizgi3d')" title="3D'den seç">🎯</button></div>
        <div class="sd-row"><label>Açı</label><div class="sd-num"><input type="number" min="-360" max="360" step="5" [ngModel]="el.aci ?? 45" (ngModelChange)="setNum('aci',$event)"/><span>°</span></div></div>
        <div class="sd-row"><label>Dönme Ekseni</label>
          <select [ngModel]="el.eksenTip || 'z'" (ngModelChange)="set('eksenTip',$event)"><option value="x">X</option><option value="y">Y</option><option value="z">Z</option></select></div>
        <div class="sd-row"><label>Uzunluk</label><div class="sd-num"><input type="number" min="0.1" step="1" [ngModel]="el.param ?? 40" (ngModelChange)="setNum('param',$event)"/><span>mm</span></div></div>
        @if(!cizgiler().length){ <div class="sd-bos">Önce bir çizgi oluştur.</div> }
      </div>
    } @else {
      <div class="sd-grup"><div class="sd-bas">Açıortay (İki Çizgi)</div>
        <div class="sd-row"><label>Çizgi 1</label>
          <select [ngModel]="el.ref1 ?? -1" (ngModelChange)="setNum('ref1',$event)">
            <option [value]="-1">— seç —</option>@for(o of cizgiler(); track o.deger){ <option [value]="o.deger">{{o.etiket}}</option> }
          </select><button class="sd-pick" (click)="ref3d('ref1','cizgi3d')" title="3D'den seç">🎯</button></div>
        <div class="sd-row"><label>Çizgi 2</label>
          <select [ngModel]="el.ref2 ?? -1" (ngModelChange)="setNum('ref2',$event)">
            <option [value]="-1">— seç —</option>@for(o of cizgiler(); track o.deger){ <option [value]="o.deger">{{o.etiket}}</option> }
          </select><button class="sd-pick" (click)="ref3d('ref2','cizgi3d')" title="3D'den seç">🎯</button></div>
        <div class="sd-row"><label>Uzunluk</label><div class="sd-num"><input type="number" min="0.1" step="1" [ngModel]="el.param ?? 40" (ngModelChange)="setNum('param',$event)"/><span>mm</span></div></div>
        @if(cizgiler().length < 2){ <div class="sd-bos">Önce 2 çizgi oluştur.</div> }
      </div>
    }

    @if(el.cizgiTip === 'tanjant'){
      <div class="sd-grup"><div class="sd-bas">Eğriye Teğet</div>
        <div class="sd-row"><label>Eğri</label>
          <select [ngModel]="el.ref1 ?? -1" (ngModelChange)="setNum('ref1',$event)">
            <option [value]="-1">— seç —</option>@for(o of tumEgriler(); track o.deger){ <option [value]="o.deger">{{o.etiket}}</option> }
          </select><button class="sd-pick" (click)="ref3d('ref1','cizgi3d')" title="3D'den seç">🎯</button></div>
        <div class="sd-row"><label>Konum (0-1)</label><div class="sd-num"><input type="number" min="0" max="1" step="0.05" [ngModel]="el.oran ?? 0.5" (ngModelChange)="setNum('oran',$event)"/></div></div>
        <div class="sd-row"><label>Uzunluk</label><div class="sd-num"><input type="number" min="0.1" step="1" [ngModel]="el.param ?? 40" (ngModelChange)="setNum('param',$event)"/><span>mm</span></div></div>
        @if(!tumEgriler().length){ <div class="sd-bos">Önce bir eğri oluştur.</div> }
      </div>
    } @else if(el.cizgiTip === 'normal'){
      <div class="sd-grup"><div class="sd-bas">Normal Yönü</div>
        <div class="sd-row"><label>Düzlem</label>
          <fikoyt-duzlem-secici [element]="el" [yonetici]="yon"></fikoyt-duzlem-secici></div>
        <div class="sd-row"><label>Uzunluk</label><div class="sd-num"><input type="number" min="0.1" step="1" [ngModel]="el.param ?? 40" (ngModelChange)="setNum('param',$event)"/><span>mm</span></div></div>
        <div class="sd-bos">İpucu: Başlangıcı "🎯 Yüze Tıkla" ile koyarsan yüzey normali kullanılır.</div>
      </div>
    }

    <div class="sd-altbar"><button class="sd-btn sd-ok" (click)="tamam()">✔ Tamam</button><button class="sd-btn sd-sil" (click)="sil()">🗑</button></div>
  </div>`,
  styles: [FIKO_DIALOG_STIL]
})
export class FikoCizgiDialog {
  @Input() element: any;
  @Input() yonetici: any;
  @Input() pencere: any;
  get el() { return this.element; }
  get yon() { return this.yonetici; }
  constructor(public CD: ChangeDetectorRef) {}
  ngOnDestroy(): void { this.yonetici?.dialogSecimTemizle?.(this.element); }

  noktalar(): any[] { return this.yonetici?.noktaSecenekleri?.(this.element) || []; }
  cizgiler(): any[] { return this.yonetici?.egriSecenekleri?.(this.element) || []; }
  tumEgriler(): any[] { return this.yonetici?.tumEgriSecenekleri?.(this.element) || []; }
  ref3d(anahtar: string, tip: string): void { this.yonetici?.refSecBaslat?.(this.element, anahtar, [tip], () => this.CD.markForCheck()); }
  koord3d(ax: string, ay: string, az: string): void { this.yonetici?.koord3dYerlestir?.(this.element, ax, ay, az, () => this.CD.markForCheck()); }
  set(a: string, v: any): void { this.yonetici?.padGuncelle(this.element, a, v); this.CD.markForCheck(); }
  setNum(a: string, v: any): void { const n = +v; if (!isNaN(n)) this.yonetici?.padGuncelle(this.element, a, n); this.CD.markForCheck(); }
  private kapat(): void { (this.pencere?.instance || this.pencere)?.kapa?.(); }
  tamam(): void { this.kapat(); }
  sil(): void { this.yonetici?.featureSil(this.element); this.kapat(); }
}
